/**
 * Download a file from an authenticated API endpoint.
 *
 * A plain <a href="/api/..."> sends no Authorization header, so every such
 * link answered 401 and the file looked missing. This fetches the bytes with
 * the bearer token and saves them from a blob instead.
 */
export const downloadWithAuth = async (url, fileName, token) => {
  const response = await fetch(url, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) {
    throw new Error(`Download failed (${response.status})`);
  }
  const blob = await response.blob();
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = fileName || 'download';
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(objectUrl);
};
